export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14864.5952c4cc.jpg";